import { fileUrl } from "@/lib/api";

export const QILogo = ({ profile, size = "w-14 h-14", text = "text-lg" }) => {
  const src = fileUrl(profile?.logo_path);
  const initials = (profile?.company_name || "QI").replace(/\[.*?\]\s*/, "").split(/\s+/).slice(0, 2).map((w) => w[0]).join("").toUpperCase();
  if (src) {
    return (
      <div className={`${size} rounded-2xl bg-white flex items-center justify-center overflow-hidden shrink-0`}>
        <img src={src} alt={`${profile.company_name} logo`} className="w-full h-full object-contain p-1.5" />
      </div>
    );
  }
  return (
    <div className={`${size} rounded-2xl bg-gradient-to-br from-qi-pink/30 to-qi-pink/5 border border-qi-pink/30 flex items-center justify-center font-display font-black text-white ${text} shrink-0`}>
      {initials}
    </div>
  );
};
